/**
 * Splits an array into sub arrays.
 *
 * @param {array} array Array to chunk
 * @param {number} size Size of the chunk
 */
export function chunk(array, size) {
	let chunks = [];
	let i = 0;
	let n = array.length;

	while (i < n) {
		chunks.push(array.slice(i, i += size));
	}

	return chunks;
}

export function first(array) {
	return (array && array.length) ? array[0] : undefined;
}

export function last(array) {
	let length = array == null ? 0 : array.length;

	return length ? array[length - 1] : undefined;
}

export function ensureArray(value) {
	if (Array.isArray(value)) {
		return value;
	} else {
		return [value];
	}
}
